import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ZpDataService } from '../../services/zp-data.service';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { Subscription } from 'rxjs';
import { IUser } from 'src/app/models/user.model';
import { UserInfoService } from 'src/app/services/user-info.service';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-sign-up-completed',
  templateUrl: './sign-up-completed.component.html',
  styleUrls: ['./sign-up-completed.component.scss']
})
export class SignUpCompletedComponent implements OnInit {
  public clientId;
  public subscription: Subscription
  public myUser: IUser;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ZpDataService: ZpDataService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService,
    private userInfoService: UserInfoService) { }

  async ngOnInit() {
    await this.getMyUser();
    this.subscription = this.userInfoService.getMessage().subscribe(user => {
      this.myUser = JSON.parse(user);
    });
    this.sideNavBarVisibilityService.hideSideNav = true;
    this.clientId = this.activatedRoute.snapshot.paramMap.get("id")
    // if(this.clientId){
    //   if(!this.ZpDataService.loggedIn()){
    //     this.ZpDataService.redirectUrl("/sign-up-completed", {id:this.clientId});
    //     this.goto("log-in");
    //   }else{
    //     this.ZpDataService.attemptSessionRestore(true);
    //
    //     this.goto('about-me-edit/'+this.clientId);
    //   }
    // }
  }

  async getMyUser() {
    if (!this.myUser) {
      await this.ZpDataService.getUser();
    }
  }

  goto(url: string) {
    this.router.navigate(['/' + url]);
  }
}
